import SwipableContainer from "./SwipableContainer";
export default SwipableContainer;
